// extracted by mini-css-extract-plugin
module.exports = {"goscontainer":"HomeLayout_goscontainer_eX97b"};